<template>
    <div class="container">
        <div class="common-header-wrap">
            <div>
                <div class="ui-detail-header">
                    <span class="iconfont" @click="goBack">&#xe6ee;</span>
                    <div class="navbar-wrapper">
                         {{titleName}}
                    </div>
                    <span class="iconfont right" @click="popupMore">&#xe680;<div v-if="showDot" class="dot"></div></span>
                </div>
                <header-more  v-show="popupVisible" ></header-more>
            </div>
        </div>
        <template>
            <div v-if="activeIndex === 0" style="height:calc(100vh - 43px);overflow:auto"  ref="container1">
                <div class="video-warp">
                    <video style="width:100%" :src="knowledge_info.knowledge_url" ref="video1" controls="controls">
                        your browser does not support the video tag
                    </video>
                    <p class="video-title">{{knowledge_info.knowledge_title}}</p>
                    <div class="video-info">
                        <span>{{knowledge_info.knowledge_play}}播放</span>
                        <span><img @click="handleDianzan" src="../../assets/image/dianzan.png">{{knowledge_info.knowledge_zan}}</span>
                    </div>
                </div>
                <div class="warp">
                    <div class="tuijian">同类推荐</div>
                    <template v-for="(item,idss) in knowledge_list" >
                            <div class="list-item1" :key="idss" @click="handleTo(item)">
                                <div class="list-item-left">
                                    <img class="bg-list-img" :src="item.knowledge_img" alt="">
                                </div>
                                <div class="list-item-right">
                                    <div class="list-item-title">{{item.knowledge_title}}</div>
                                    <div>
                                        <p class="biaoji">{{item.knowledge_type === 'n'?'免费':'收费'}}</p>
                                        <p class="sub-title"><span>{{item.knowledge_author}}</span><span class="gray">{{item.knowledge_play}}播放</span></p>
                                    </div>
                                </div>

                                    <!-- <img class="bg-list-img" v-else src="../../assets/image/list.png" alt=""> -->
                            </div>

                            </template>
                </div>
            
            </div>
        </template>
       <mt-popup v-model="showDialog" popup-transition="popup-fade" class="popup" >
            <div class="pop-content">
                <div class="pop-img">
                    <img src="../../assets/image/tick.png" />
                    <p>领券成功！感谢您的参与，祝您购物愉快~</p>
                </div>
                
                <div class="pop-btn" @click="showDialog=false">确定</div>
            </div>
        </mt-popup>
        <div class="loading-warp" v-if="isloading">
           <img src="../../assets/image/new_mp_loade.gif" alt="">
            <p>加载中...</p>
        </div>
    </div>
</template>
<script>
import { getKnowledgeDetail,zanKnowledge } from '../../api/video'
import { Toast ,Indicator} from 'mint-ui'
import EmptyRecord from '../../components/EmptyRecord'
import HeaderMore from '../HeaderMore'
import { vactInfo ,vact_fdetail,vact_receive} from '../../api/reelCenter'
import Tab from 'vant/lib/tab';
import 'vant/lib/tab/style';
import Tabs from 'vant/lib/tabs';
import 'vant/lib/tabs/style';
import List from 'vant/lib/list';
import 'vant/lib/list/style';
import Empty from 'vant/lib/empty';
import 'vant/lib/empty/style';

import { mapState } from 'vuex'
export default {
  name: 'videoDetail',
  components: {
    EmptyRecord,
    HeaderMore,
    Tab,
    Tabs,
    List,
    Empty
  },
  data () {
    return {
      banner:'',
      activity_fen:[],
      active:0,
      ac_id:'',
      dataList:[],
      page:1,
      selected: 1,
      activeIndex: 0,
      isDx:false, // 点了兑换
      code:'',
      yhjInfo:{},
      num1:0,
      num2:0,
      num3:0,
      isMore: true, // 是否有更多
      popupVisible: false, 
      showDot:false,
      tjData:[],
      list: [],
      loading: false,
      finished: false,
      isFirst:true,
      hasmore:false,
      showDialog:false,
      titleName: '视频详情',
      isloading:false,
      isRequst:false, // 是否正在请求
      knowledge_info: {},
      knowledge_list: []

    }
  },
  computed: mapState({
    token: state => state.member.token
  }),
  created() {
    this.initPage()
  },
  mounted() {
    this.$refs.video1.controlsList = "nodownload"
  },
  methods: {
    // handleGetJuan(index) {
    //     vact_receive({id:this.dataList[index].id,key:this.token}).then(res => {
    //         if (res.code === 10000) {
    //             this.showDialog = true
    //             setTimeout(() => {
    //                 this.$set(this.dataList[index],'isLq',true)  
    //             },100)
    //         }   
    //     }).catch(function (error) {
    //         Toast(error.message)
    //     })
    // },
    // onLoad() {
    //     if (this.isFirst) return
    //     if (!this.hasmore) return
    //     if (this.isRequst) return // 正在请求就不用再请求
    //     this.page = this.page + 1
    //     this.isRequst = true
    //     vact_fdetail({
    //        knowledge_id: this.$route.query.knowledge_id || '14',
    //        ac_id: this.ac_id,
    //        page: this.page,
    //        per_page: 5
    //     }).then(res => {
    //         if(res.code === 10000) {
    //             if (this.page === 1) {
    //               this.dataList = res.result.adv_list || []  
    //             } else {
    //               res.result.adv_list = res.result.adv_list || []
    //               this.dataList = this.dataList.concat(res.result.adv_list)
    //             }
    //             this.isRequst = false
    //             this.loading = false
    //             this.hasmore = res.result.hasmore
    //             if(!this.hasmore) {
    //                 this.finished = true
    //             }
    //         }
    //     }).catch(function (error) {
    //         Toast(error.message)
    //     })
    // },
    handleTo(item) {
        this.$router.push({
            name:'videoDetail',
            query:{
                knowledge_id: item.knowledge_id
            }
        })
    },
    initPage() {
        let id = this.$route.query.knowledge_id || '14'
        this.isloading = true
       getKnowledgeDetail({knowledge_id:id}).then(res => {
           this.isloading = false
           if(res.code === 10000) {
              this.knowledge_info = res.result.knowledge_info
              this.knowledge_list = res.result.knowledge_list
           }
       }).catch(function (error) {
           this.isloading = false
            Toast(error.message)
        })
    },
    handleDianzan() {
        let id = this.$route.query.knowledge_id || '14'
        zanKnowledge({knowledge_id:id}).then(res => {
           if(res.code === 10000) {
              Toast('点赞成功')
              let num = Number(this.knowledge_info.knowledge_zan) + 1
              this.$set(this.knowledge_info,'knowledge_zan',num)
           }
       }).catch(function (error) {
            Toast(error.message)
        })
    },
    
    handleChange() {
       this.page = 1
       this.hasmore = false
        this.isFirst = true
       this.ac_id =  this.activity_fen[this.active].id
        if (!this.ac_id) {
            this.dataList = JSON.parse(JSON.stringify(this.tjData))
            return
        }
        Indicator.open()
       vact_fdetail({
           knowledge_id: this.$route.query.knowledge_id || '14',
           key: this.token || '',
           ac_id: this.ac_id,
           page: this.page,
           per_page: 5
       }).then(res => {
           Indicator.close()
            if(res.code === 10000) {
                this.dataList = res.result.adv_list || []
                this.hasmore = res.result.hasmore
                if(!this.hasmore) {
                    this.finished = true
                } else {
                    this.finished = false
                }
                 this.isFirst = false
                 
                console.log(231)
            }
       }).catch(function (error) {
           Indicator.close()

            Toast(error.message)
        })

    },
    popupMore () {
      if (!this.popupVisible) {
        this.popupVisible = true
      } else {
        this.popupVisible = false
      }
    },
    goBack () {
      this.$router.go(-1)
    },
     dateToStr(times){ 
        let datetime = new Date(times)
        var year = datetime.getFullYear();
        var month = datetime.getMonth()+1;//js从0开始取 
        var date = datetime.getDate(); 
        return year + "." + month + "." + date;
    },
    handleClickDx() {
       
      let params = { 'page': 0, 'per_page': 1 }
      getPointbycode(this.code).then(res => {
         this.isDx = true
        //  getVoucherList({...params}).then(ress => {
        //     console.log(this.yhjInfo,'this.yhjInfo')
            this.yhjInfo = res.result || {}
            this.yhjInfo.startdate = this.dateToStr(this.yhjInfo.voucher_startdate*1000)
            this.yhjInfo.enddate = this.dateToStr(this.yhjInfo.voucher_enddate*1000)

        //  })
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    alignClick() {
      this.isDx = false
      this.code = ''
    },
    handleQwsy(item) {
        if (item.vouchertemplate_gettype == '1') {
           this.$router.push({
                name:'HomeStoredetail',
                query:{
                id: item.vouchertemplate_store_id
                }
            })
        } else if (item.vouchertemplate_gettype == '2') {
            this.$router.push({
                name:'HomeGoodsdetail',
                query:{
                  goods_id: item.vouchertemplate_goods_id
                }
            })
        } else {
            this.$router.push({
                name:'HomeIndex'
            })
        }
        
    },
    handleGoGoods(item) {
         this.$router.push({
            name:'HomeGoodsdetail',
            query:{
                goods_id: item.goods_id
            }
        })
    }
    
  },
  watch:{
      '$route'(to,form) {
           this.initPage()
           this.$refs.container1.scrollTop = 0
      }
  }
}
</script>
<style scoped lang="scss"> 

    .container .tab-nav{margin-bottom:.5rem}
    .container .tab-containt{height: 0;overflow: hidden}
    .container .tab-containt.active{height: auto}
    .content-warp {
        height: calc(100vh - 4.5rem);
        background: #fff;
        padding:.7rem;
        font-size:.7rem;
        line-height: 1.5;
    }
    .content-warp input {
        width: calc(100% - 0.5rem);
        margin:0.25rem;
        height:2rem;
        margin-top:2rem;
        padding:0 .7rem;
        box-sizing: border-box;
    }
    .content-warp1 {
        background: #f5f5f5;
    }
    .content-warp1 p {
        text-align: center;
    }
    .content-warp1 > div {
                padding:1rem 0;
    }
    .border-b{
       border-bottom:1px solid #666;
    }
    .content-warp1 .bottom {
        padding-left:30px;
        padding-right: 30px;
    }
    .content-warp1 .bottom p {
        text-align: left;

    }
     .content-warp1 .mint-button--normal {
         background: #aaa;
    }
     .ui-detail-header {
	padding: 0 0.45rem;
	// height:3.2rem;
	background: rgba(255, 255, 255, 1);
	border-bottom: 1px solid rgba(232, 234, 237, 1);
	color: #55595f;
	font-size: 0.8rem;
	width: auto;
	display: flex;
	justify-content: center;
	align-content: center;
	align-items: center;
	flex-basis: auto;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	.iconfont {
		width: 1.2rem;
		font-size:0.8rem;
		height: 1.2rem;
		line-height:1.2rem;
		cursor: pointer;
		position: absolute;
		left: 0.45rem;
		top: 0.5rem;
	}
	.iconfont.right{left:auto;right:0.45rem;-webkit-tap-highlight-color: transparent;}
	div.navbar-wrapper {
		line-height: 2.1rem;
		div {
			// line-height: 2.1rem;
			border-bottom: 0;
			display: inline-block;
			margin-right:2.4rem;
			color: #55595f;
			background-color: #fff;
			&.navbar_active {
				color: $primaryColor;
				border-bottom: 0.1rem solid $primaryColor;
			}
			&:last-child {
				margin-right: 0;
			}
			&:focus {
				outline: none;
			}
		}
	}
}

    .mint-popup {
      border-radius: 10px;
      overflow: hidden;
    }
        .pop-content {
            width:80vw;
            background: #fff;
            .pop-img {
                padding:25px 25px 5px;
                text-align: center;
                font-size: 16px;
                img {
                    width:60px;
                }
            }
            .pop-btn {
                margin-top:20px;
                line-height: 50px;
                text-align: center;
                font-size: 16px;
                border-top:1px solid #f3f3f3;
                color:#e93b3d;
                cursor: pointer;
                &:active {
                    background: #f2f2f2;
                }
            }
        }
        .red {
            color:#e93b3d;
        }
       /deep/ .van-tab {
            color:#999;
        }
        /deep/ .van-tab--active {
            color:#323233;
        }
        .loading-warp {
            width:100vw;
            height:100vh;
            position: fixed;
            top:0;
            left:0;
            background: rgba(0,0,0,0.5);
            z-index:10000;
            text-align: center;
            img {
                width:100px;
                margin-top:50%;
            }
            p {
                font-size:14px;
                color:#fff;
                margin-top:10px;
            }
        }
       
        .list-item1 {
            position: relative;
            padding:15px;
            display: flex;
            background: #fff;
            border-bottom:1px solid #f2f2f2;
            box-sizing: border-box;
            .list-item-left {
                width:45%;
                padding-top:28%;
                position: relative;
                height:0;
                img {
                    position: absolute;
                    width:100%;
                    height:100%;
                    top:0;
                    left:0;
                }
            }
            .list-item-right {
                width:55%;
                box-sizing: border-box;
                padding-left:10px;
                    display: flex;
                flex-flow: column;
                justify-content: space-between;
                .list-item-title {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    font-size:16px;
                    line-height: 1.5;
                }
                .biaoji {
                    color:red;
                    font-size: 12px;
                    margin-bottom:5px;
                }
                .sub-title {
                    font-size: 14px;
                    display: flex;
                    justify-content: space-between;
                    .gray {
                        color:#999;
                    }
                    
                }
                
            }
        }
    .video-warp {
        padding:15px;
        background: #fff;
        .video-title {
            font-size:16px;
            line-height: 1.5;
        }
        .video-info {
            font-size: 14px;
            line-height: 1.5;

            display: flex;
            justify-content: space-between;
            img {
                height:14px;
                vertical-align: middle;
                margin-right:2px;
            }
        }
    }
    .tuijian {
        background: #fff;
        padding:0 15px 0;
        font-size: 16px;
        position: relative;
        &:after {
            content: '';
            position: absolute;
            display: block;
            width:5px;
            top:3px;
    left: 84px;
            height:16px;
            background: #ee0a24
        }
    }
</style>
